<template>
  <v-date-picker
    v-if="show"
    ref="datepicker"
    class="rounded w-100"
    locale="us"
    :timezone="timezone"
    :is-range="isRange"
    :is-required="isRequired"
    :value="value"
    :mode="mode"
    :masks="masks"
    :popover="popoverOptions"
    :min-date="minDate"
    :max-date="maxDate"
    :model-config="modelConfig"
    @input="(val) => onInput(val)"
  >
    <template v-slot="{ inputValue, inputEvents }">
      <template v-if="isRange">
        <b-input-group class="d-flex flex-nowrap align-items-center">
          <BootstrapCustomInput
            v-model="inputValue.start"
            v-on="inputEvents.start"
            :mask="dateMask"
            :placeholder="dateFormat"
            :disabled="disabled"
            :class="{ 'datepicker-readonly-input': !disabled }"
          />
          <span class="mx-2">&#10095;</span>
          <BootstrapCustomInput
            v-model="inputValue.end"
            v-on="inputEvents.end"
            :mask="dateMask"
            :placeholder="dateFormat"
            :disabled="disabled"
            :class="{ 'datepicker-readonly-input': !disabled }"
          />
        </b-input-group>
      </template>
      <template v-else>
        <BootstrapCustomInput
          v-model="inputValue"
          v-on="inputEvents"
          :mask="dateTimeMask"
          :placeholder="dateFormat"
          :disabled="disabled"
          :class="{ 'datepicker-readonly-input': !disabled }"
        />
        <i v-if="!disabled" class="fal fa-times datepicker-close-icon" @click="onClear" />
      </template>
    </template>
  </v-date-picker>
</template>

<script>
import { datePickerMethods } from '../../../mixins/date';
import BootstrapCustomInput from './bootstrapCustomInput';

export default {
  name: 'DatePickerInput',
  mixins: [datePickerMethods],
  components: { BootstrapCustomInput },
  props: {
    isRange: {
      type: Boolean,
      default: false,
    },
    isRequired: {
      type: Boolean,
      default: false,
    },
    value: {
      type: [Object, Date, String],
      default: null,
    },
    mode: {
      type: String,
      default: 'date',
    },
    timezone: {
      type: String,
      default: '',
    },
    masks: {
      type: Object,
      default: () => {
        return {
          input: 'MM/DD/YYYY',
          inputDateTime: 'MM/DD/YYYY hh:mm a',
        };
      },
    },
    withTime: {
      type: Boolean,
      default: false,
    },
    popoverOptions: {
      type: Object,
      default: () => {
        return {
          visibility: 'focus',
        };
      },
    },
    minDate: {
      type: [Date, String],
    },
    maxDate: {
      type: [Date, String],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    modelConfig: {
      type: Object,
      default: () => {
        return {
          timeAdjust: '00:00:00',
        };
      },
    },
  },
  data() {
    return {
      show: true,
      dateTimeMask: [
        /\d/,
        /\d/,
        '/',
        /\d/,
        /\d/,
        '/',
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        ' ',
        /\d/,
        /\d/,
        ':',
        /\d/,
        /\d/,
        ' ',
        /[a|p]/,
        'm',
      ],
      dateMask: '##/##/####',
    };
  },
  computed: {
    dateFormat() {
      return this.withTime ? 'MM/DD/YYYY hh:mm a' : 'MM/DD/YYYY';
    },
  },
  methods: {
    onInput(value) {
      if (this.isRange) {
        if (value && value.start && value.end) {
          if (!this.areDatesEqual(value, this.value)) {
            this.$emit('input', value);
          }
        }
      } else {
        this.$emit('input', value);
      }
    },
    areDatesEqual(newVal, oldVal) {
      if (newVal && oldVal) {
        return (
          new Date(newVal.start).getTime() === new Date(oldVal.start).getTime() &&
          new Date(newVal.end).getTime() === new Date(oldVal.end).getTime()
        );
      }
      return newVal === oldVal;
    },
    onClear() {
      this.show = false;
      this.$emit('input', undefined);
      this.$nextTick(() => {
        this.show = true;
      });
    },
  },
};
</script>
